const BRAND_ID = 5903

const PIMCORE_URL = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
    'https://headless.inmusicbrands.com' :
    'https://staging.headless.inmusicbrands.com'

const ENDPOINTS = {
    GET_CART_ID: (iso) => `/api/${iso.toLowerCase()}/get_cart_id`,
    ADD_TO_CART: (iso) => `/api/${iso.toLowerCase()}/add_to_cart`,
    REMOVE_FROM_CART: `/api/remove_from_cart`,
    GET_CART: (iso) => `/api/${iso.toLowerCase()}/get_cart`,
    CATEGORY: `/api/get_categories?brand_id=${BRAND_ID}`,
    PRODUCT: `/api/get_products?product_type=software`,
    PRICE: `/api/get_prices?product_type=software&brand_id=${BRAND_ID}`,
    PROMOTION: `/api/get_promotions`,
    COUNTRY: `/api/pim/countries`,
    REDEEM_VOUCHER: (iso) => `/api/${iso.toLowerCase()}/redeem-voucher`,
    ROLLBACK_VOUCHER: (iso) => `/api/${iso.toLowerCase()}/rollback-redemption`,
    REGISTER_PRODUCT: (iso) => `/api/${iso.toLowerCase()}/register-product`,
}

const BASE_COUNTRY_ISO = 'DE'
const FLAG_URL = 'https://flagcdn.com'
const GET_FLAG_URL = iso => `${FLAG_URL}/${iso?.toLowerCase()}.svg`

module.exports = {
    BRAND_ID,
    PIMCORE_URL,
    ENDPOINTS,
    BASE_COUNTRY_ISO,
    GET_FLAG_URL,
}

